import {Injectable} from "@angular/core";
import {CONDITION_TYPES} from "../enums/e-conditions";
import {WatchService} from "./watch.service";
import {IQuestStage} from "../interfaces/quest.definition";
import {IAchievementStage} from "../interfaces/achievement.definition";
import {ICondition} from "../interfaces/condition.definition";


@Injectable()
export class StageService {
    constructor(private watchService: WatchService) {
    }

    addTo(document: any, prop: string) {
        let stages: IQuestStage[] = document[prop];
        if (!stages) {
            return;
        }

        let stage: IQuestStage = <IQuestStage>{
            name: "new stage",
            description: "",
            conditionValue: 0,
            canBeAsked: false,
            skipCost: 0,
            condition: {
                type: CONDITION_TYPES.ESellStuff
            }
        };

        stages.push(stage);
        this.initializeConditionParams(stage.condition);
    }


    addConditionTo(document: any, prop: string):void {
        let conditions: ICondition[] = document[prop];
        if (!conditions) {
            throw new Error(`You got undefined somewhere in '${document}.${prop}'`);
        }

        let condition: ICondition = <ICondition>{ type: CONDITION_TYPES.ESellStuff };
        conditions.push(condition);
        this.initializeConditionParams(condition);
    }


    addAchievementStage(document: any, prop: string) {
        let stages: IAchievementStage[] = document[prop];
        if (!stages) {
            return;
        }

        let stage: IAchievementStage = {
            conditionValue: 0,
            description: "",
            rewards: []
        };
        stages.push(stage);
        this.watchService.notify();
    }


    initializeConditionParams(condition: ICondition) {
        this.initializeConditionParamsImpl(condition);
        this.watchService.notify();
    }


    private initializeConditionParamsImpl(condition: ICondition):ICondition {
        let params: any;

        

switch (condition.type) {
    case CONDITION_TYPES.ECompleteMarketOrder:
    case CONDITION_TYPES.ESpendStuffAny:
    case CONDITION_TYPES.EBuyInAppLot:
    case CONDITION_TYPES.ESpell:
    case CONDITION_TYPES.EOwnSector:
    case CONDITION_TYPES.EBuff:
    case CONDITION_TYPES.EVendor:
    case CONDITION_TYPES.EQuestComplete:
    case CONDITION_TYPES.EInteractWithAnimal:
    case CONDITION_TYPES.ESpendStuffShop:
    case CONDITION_TYPES.EEnterGameEvent:
    case CONDITION_TYPES.ESpendStuffAnyShop:
        params = {"id":0};
        break;

    case CONDITION_TYPES.EBuyStuffCategory:
    case CONDITION_TYPES.ESpendGoldOnCategory:
        params = {"category":"hidden"};
        break;

    case CONDITION_TYPES.EAccelerateSpell:
        params = {"target":[]};
        break;

    case CONDITION_TYPES.ESellAny:
    case CONDITION_TYPES.ECompleteZeppelinSubOrder:
    case CONDITION_TYPES.ECompleteZeppelinOrder:
    case CONDITION_TYPES.EAnySpell:
    case CONDITION_TYPES.EInteractWithShmu:
    case CONDITION_TYPES.EInteractWithAnimalAny:
    case CONDITION_TYPES.EDaylyBonusGot:
    case CONDITION_TYPES.EOwnLevel:
    case CONDITION_TYPES.ERichResourceLimit:
    case CONDITION_TYPES.EGoldLoteryTicket:
    case CONDITION_TYPES.EQuestDiller:
    case CONDITION_TYPES.EFriends:
    case CONDITION_TYPES.EFriendActions:
    case CONDITION_TYPES.EKillFriendsNuts:
    case CONDITION_TYPES.EFriendZeppelin:
    case CONDITION_TYPES.EDailyQuest:
    case CONDITION_TYPES.EAnimalEscape:
    case CONDITION_TYPES.EShmuFear:
    case CONDITION_TYPES.EAnimalFear:
    case CONDITION_TYPES.EFireBuilding:
    case CONDITION_TYPES.ENutsOnMap:
    case CONDITION_TYPES.EShmuOnMap:
    case CONDITION_TYPES.ECollectAnyProduction:
    case CONDITION_TYPES.EBuffAny:
    case CONDITION_TYPES.EBuildAny:
    case CONDITION_TYPES.EUpgradeAny:
    case CONDITION_TYPES.ESectorUnlockAny:
        params = {};
        break;

    case CONDITION_TYPES.ESaveUpAndClean:
        params = {"resource":0};
        break;

    case CONDITION_TYPES.EStartAction:
    case CONDITION_TYPES.EQueueAction:
    case CONDITION_TYPES.EFinishAction:
        params = {"actionIds":[]};
        break;

    case CONDITION_TYPES.EApplyAction:
        params = {"actionIds":[],"includeAlreadyApplied":false};
        break;

    case CONDITION_TYPES.ECompleteAnyOfOrders:
        params = {"templateIds":[]};
        break;

    case CONDITION_TYPES.EStartProductionOn:
    case CONDITION_TYPES.EApplyProductionOn:
        params = {"categories":[]};
        break;

    case CONDITION_TYPES.EOwnMapObject:
        params = {"obj":[],"includePending":false};
        break;

    case CONDITION_TYPES.ECollectFromObject:
        params = {"ids":[]};
        break;

    case CONDITION_TYPES.ESellStuff:
    case CONDITION_TYPES.EReceiveIncome:
    case CONDITION_TYPES.ESaveUpResource:
    case CONDITION_TYPES.EReceiveStuff:
        params = {"resourceIds":[]};
        break;

    case CONDITION_TYPES.ERichDailyQuestStage:
        params = {"stageNum":1};
        break;

    case CONDITION_TYPES.ECollectFromTag:
        params = {"tags":[]};
        break;

    default:
        throw new Error("[conditionService] Unknown condition type: " + condition.type);
}

        condition.params = params;
        return condition;
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/conditionService.ts